import {
  GET_JOBCATEGORIES, GET_JOBCATEGORIES_SUCCESS, GET_JOBCATEGORIES_FAIL,
  GET_JOBCATEGORY_DETAILS, GET_JOBCATEGORY_DETAILS_SUCCESS, GET_JOBCATEGORY_DETAILS_FAIL,
  JOBCATEGORY_CREATE, JOBCATEGORY_CREATE_FAIL, JOBCATEGORY_CREATE_SUCCESS,
  JOBCATEGORY_DELETE, JOBCATEGORY_DELETE_FAIL, JOBCATEGORY_DELETE_SUCCESS,
  JOBCATEGORY_UPDATE, JOBCATEGORY_UPDATE_FAIL, JOBCATEGORY_UPDATE_SUCCESS,
  RESET,
  GET_LOOKUP_JOBCATEGORIES, GET_LOOKUP_JOBCATEGORIES_SUCCESS, GET_LOOKUP_JOBCATEGORIES_FAIL
} from "./actionTypes";

const initialState = {
  jobCategoryList: [],
  jobCategory: {},
  postingResult: {},
  loading: false,
  loadingJobCategoryDetails: false,
  jobCategorySetting: {},
  loadingJobCategorySetting: false,
  lookupJobCategoryList: [],
  loadingLookupJobCategoryList: false,
  error: {
    message: "",
  },
};

const JobCategoryReducer = (state = initialState, action) => {
  if (!action) return state;

  switch (action.type) {
    case GET_JOBCATEGORIES:
      state = { ...state, loading: true };
      break;
    case GET_JOBCATEGORIES_SUCCESS:
      state = { ...state, jobCategoryList: action.payload, loading: false };
      break;
    case GET_JOBCATEGORIES_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loading: false,
      };
      break;

    case GET_LOOKUP_JOBCATEGORIES:
      state = { ...state, loadingLookupJobCategoryList: true };
      break;
    case GET_LOOKUP_JOBCATEGORIES_SUCCESS:
      state = {
        ...state,
        lookupJobCategoryList: action.payload,
        loadingLookupJobCategoryList: false,
      };
      break;
    case GET_LOOKUP_JOBCATEGORIES_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingLookupJobCategoryList: false,
      };
      break;

    case GET_JOBCATEGORY_DETAILS:
      state = { ...state, loadingJobCategoryDetails: true };
      break;
    case GET_JOBCATEGORY_DETAILS_SUCCESS:
      state = { ...state, jobCategory: action.payload, loadingJobCategoryDetails: false };
      break;
    case GET_JOBCATEGORY_DETAILS_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingJobCategoryDetails: false,
      };
      break;

    case JOBCATEGORY_CREATE:
      state = { ...state, postingResult: {}, loading: true };
      break;
    case JOBCATEGORY_CREATE_SUCCESS:
      state = { ...state, postingResult: action.payload, loading: false };
      break;
    case JOBCATEGORY_CREATE_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        postingResult: {},
        loading: false,
      };
      break;

    case JOBCATEGORY_UPDATE:
      state = { ...state, postingResult: {}, loading: true };
      break;
    case JOBCATEGORY_UPDATE_SUCCESS:
      state = { ...state, postingResult: action.payload, loading: false };
      break;
    case JOBCATEGORY_UPDATE_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loading: false,
      };
      break;

    case JOBCATEGORY_DELETE:
      state = { ...state, postingResult: {}, loading: true };
      break;
    case JOBCATEGORY_DELETE_SUCCESS:
      state = { ...state, postingResult: action.payload, loading: false };
      break;
    case JOBCATEGORY_DELETE_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loading: false,
      };
      break;

    case RESET:
      state = { ...state, jobCategory: {} };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};

export default JobCategoryReducer;
